(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["offers-strip"] && !Shopify.designMode) return;
  try {
    // Copy-to-clipboard for each coupon. Uses the async Clipboard API where
  // available and falls back to a hidden textarea + execCommand, which is what
  // Safari and any non-secure-context page still need.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.offers-strip__copy');
    if (!button) return;

    const code = button.dataset.offerCode;
    if (!code) return;

    const confirm = () => {
      const label = button.querySelector('.offers-strip__copy-label');
      const copied = button.querySelector('.offers-strip__copied-label');
      if (!label || !copied) return;
      label.hidden = true;
      copied.hidden = false;
      setTimeout(() => {
        label.hidden = false;
        copied.hidden = true;
      }, 2000);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(confirm).catch(() => {});
      return;
    }

    const scratch = document.createElement('textarea');
    scratch.value = code;
    scratch.setAttribute('readonly', '');
    scratch.style.position = 'absolute';
    scratch.style.left = '-9999px';
    document.body.appendChild(scratch);
    scratch.select();
    try {
      document.execCommand('copy');
      confirm();
    } catch (error) {
      // Clipboard unavailable — the code stays visible for manual copying.
    }
    document.body.removeChild(scratch);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pincode-check"] && !Shopify.designMode) return;
  try {
    // Matches a pincode against merchant rules. Rules may be exact ("110001") or
  // prefix wildcards ("400*"), separated by commas or newlines.
  class PincodeCheck extends HTMLElement {}

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pincode-check__button');
    if (!button) return;
    runCheck(button.closest('.pincode-check'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target.closest('.pincode-check__input');
    if (!input) return;
    event.preventDefault();
    runCheck(input.closest('.pincode-check'));
  });

  function parseRules(raw) {
    return (raw || '')
      .split(/[\s,]+/)
      .map((rule) => rule.trim())
      .filter(Boolean);
  }

  function matches(code, rules) {
    return rules.some((rule) => {
      if (rule.endsWith('*')) return code.startsWith(rule.slice(0, -1));
      return code === rule;
    });
  }

  function runCheck(root) {
    if (!root) return;
    const input = root.querySelector('.pincode-check__input');
    const result = root.querySelector('.pincode-check__result');
    if (!input || !result) return;

    const code = (input.value || '').trim();
    result.hidden = false;

    if (!/^\d{4,10}$/.test(code)) {
      result.dataset.state = 'no';
      result.textContent = root.dataset.invalidMessage || 'Enter a valid pincode.';
      return;
    }

    const blocked = parseRules(root.dataset.blocked);
    if (blocked.length && matches(code, blocked)) {
      result.dataset.state = 'no';
      result.textContent = root.dataset.noMessage || 'Sorry, we do not deliver to this pincode yet.';
      return;
    }

    const serviceable = parseRules(root.dataset.serviceable);
    // An empty serviceable list means "we ship everywhere except blocked".
    const ok = serviceable.length === 0 || matches(code, serviceable);

    result.dataset.state = ok ? 'yes' : 'no';
    if (ok) {
      const days = root.dataset.days;
      result.textContent = days
        ? 'Delivers to ' + code + ' in ' + days + '.'
        : 'We deliver to ' + code + '.';
    } else {
      result.textContent = 'Sorry, we do not deliver to ' + code + ' yet.';
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["recently-viewed"] && !Shopify.designMode) return;
  try {
    // Per-browser history of viewed products. Kept deliberately small and stored
  // as plain JSON so it can be inspected or cleared by the shopper.
  const STORAGE_KEY = 'recently-viewed-products';

  function readHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      // Private mode or corrupt value — behave as if there is no history.
      return [];
    }
  }

  function writeHistory(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Storage full or blocked; the list simply won't persist.
    }
  }

  function render(root) {
    const row = root.querySelector('[data-recently-viewed-row]');
    if (!row) return;

    const limit = parseInt(root.dataset.limit, 10) || 8;
    const current = root.dataset.currentHandle;
    const items = readHistory()
      .filter((item) => item && item.handle && item.handle !== current)
      .slice(0, limit);

    if (!items.length) {
      root.hidden = true;
      return;
    }

    row.textContent = '';
    items.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'recently-viewed__card';
      card.href = item.url;

      const media = document.createElement('div');
      media.className = 'recently-viewed__media';
      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const title = document.createElement('p');
      title.className = 'recently-viewed__title';
      title.textContent = item.title || '';

      const price = document.createElement('p');
      price.className = 'recently-viewed__price';
      const now = document.createElement('span');
      now.textContent = item.price || '';
      price.appendChild(now);
      if (item.compare) {
        const was = document.createElement('span');
        was.className = 'recently-viewed__compare';
        was.textContent = item.compare;
        price.appendChild(was);
      }

      card.append(media, title, price);
      row.appendChild(card);
    });

    root.hidden = false;
  }

  function init(root) {
    const handle = root.dataset.currentHandle;

    // Record this product first, then render — so the freshly viewed item is in
    // history for the *next* page rather than showing on its own page.
    if (handle) {
      const entry = {
        handle,
        title: root.dataset.currentTitle,
        url: root.dataset.currentUrl,
        image: root.dataset.currentImage,
        price: root.dataset.currentPrice,
        compare: root.dataset.currentCompare,
      };
      const history = readHistory().filter((item) => item && item.handle !== handle);
      history.unshift(entry);
      writeHistory(history.slice(0, 20));
    }

    render(root);
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(init);

  // Re-run after a Section Rendering API morph replaces the block.
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-recently-viewed]').forEach(render);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    /**
   * Live measurement chip: "SIZE: XS | WAIST 28-30 | LENGTH 40".
   *
   * Reads the size the shopper has selected and looks its measurements up in the
   * same table that powers the modal, so the two can never disagree. Matching is
   * done by comparing the selected option's text against the size column names,
   * which avoids depending on the variant picker's internal markup — that
   * differs between swatch, button and dropdown modes.
   */
  function sizeGuideChips() {
    document.querySelectorAll('[data-size-guide]').forEach((root) => {
      const chip = root.querySelector('[data-size-chip]');
      if (!chip) return;

      let table;
      try {
        table = JSON.parse(root.dataset.sizeTable);
      } catch (error) {
        return;
      }
      if (!table || !Array.isArray(table.sizes) || !table.sizes.length) return;

      const normalise = (value) => String(value || '').trim().toLowerCase();
      const sizeSet = table.sizes.map(normalise);

      // Find whichever selected control matches a known size name.
      let selected = null;
      const form = root.closest('form') || document;
      const scope = form === document ? document : form;

      scope.querySelectorAll('input:checked, option:checked, [aria-checked="true"], [aria-selected="true"]').forEach((el) => {
        const candidates = [el.value, el.textContent, el.getAttribute('data-value')];
        candidates.forEach((candidate) => {
          const index = sizeSet.indexOf(normalise(candidate));
          if (index !== -1 && selected === null) selected = index;
        });
      });

      if (selected === null) {
        chip.hidden = true;
        return;
      }

      const unit = root.dataset.unit || '';
      const parts = [`SIZE: <b>${table.sizes[selected]}</b>`];

      table.rows.forEach((row) => {
        const value = row.values[selected];
        if (value) parts.push(`<b>${row.label}</b> ${value}${unit ? ' ' + unit : ''}`);
      });

      chip.innerHTML = parts.join(' <span class="size-guide__chip-sep">|</span> ');
      chip.hidden = false;
    });
  }

  sizeGuideChips();
  document.addEventListener('change', sizeGuideChips);
  document.addEventListener('click', sizeGuideChips);
  document.addEventListener('shopify:section:load', sizeGuideChips);

  // Native <dialog> gives backdrop, Esc and focus trapping without extra code.
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sizeGuideOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-size-guide-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    // Click on the backdrop (the dialog element itself, outside its content).
    const dialog = event.target.closest('.size-guide__dialog');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;

    // The real controls this bar proxies. Queried lazily because the variant
    // picker can re-render them via the Section Rendering API.
    const realAdd = () =>
      document.querySelector(
        'product-form-component button[type="submit"], .add-to-cart-button, [data-add-to-cart]'
      );
    const realBuyNow = () =>
      document.querySelector('.shopify-payment-button__button');
    const realPrice = () =>
      document.querySelector('.view-product-title__price .price, product-price .price, .price');

    const addBtn = bar.querySelector('[data-sticky-add]');
    const buyBtn = bar.querySelector('[data-sticky-buy-now]');
    const priceEl = bar.querySelector('[data-sticky-price]');

    // Only offer Buy it now if the real accelerated checkout exists.
    if (buyBtn && realBuyNow()) buyBtn.hidden = false;

    addBtn?.addEventListener('click', () => realAdd()?.click());
    buyBtn?.addEventListener('click', () => realBuyNow()?.click());

    // Mirror price and disabled state so the bar never contradicts the buy box.
    function sync() {
      const real = realAdd();
      if (real && addBtn) addBtn.disabled = real.disabled;

      const p = realPrice();
      if (p && priceEl) {
        const text = p.textContent.trim();
        if (text) priceEl.textContent = text;
      }
    }

    document.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
    sync();

    // Reveal once the real buy buttons leave the viewport.
    const anchor = realAdd()?.closest('product-form-component, .buy-buttons, form') || realAdd();
    if (!anchor || !('IntersectionObserver' in window)) {
      bar.hidden = false;
      bar.setAttribute('data-visible', '');
      return;
    }

    bar.hidden = false;
    new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) bar.removeAttribute('data-visible');
        else bar.setAttribute('data-visible', '');
      },
      { rootMargin: '0px 0px -10% 0px' }
    ).observe(anchor);
  })();
  } catch(e) { console.error(e); }
})();

})();
